import { render } from "./BaseLogo.vue?vue&type=template&id=7543d46d"
import script from "./BaseLogo.vue?vue&type=script&lang=js"
export * from "./BaseLogo.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__